import { Component, OnInit } from '@angular/core';
import { IdentityService } from '../services/identity.service'
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html'
})
export class ProfileComponent implements OnInit {
  auth: any;
  updatingRoles=false;

  constructor(private identityService: IdentityService) { }

  async ngOnInit() {
    this.auth = await this.identityService.getIdentity();

  }

  async updateMyRoles(){
    this.updatingRoles = true;
    const updateMyRoles = firebase.functions().httpsCallable("updateMyRoles");
    await updateMyRoles();
    this.updatingRoles = false;
  }

}
